import { ReportPromoType, TableReportPromoType } from 'entities/reportPromo';
import { CityType } from 'shared/types';
import dayjs from 'dayjs';
import { ConstantsType } from 'features/getParticipants/api/getConstantsApi';
import { findKeyByValue } from 'shared/utils';

export const useDefaultReportPromoTableValues = (
  promoList: ReportPromoType,
  cachedCities: Record<number, CityType>,
  directionValues: ConstantsType | undefined,
): TableReportPromoType[] => {
  if (!promoList?.items.length) {
    return [];
  }

  return promoList.items.map((promo) => ({
    activity_id: promo.activity.id,
    activity_name: promo.activity?.name.ru,
    door_code: promo.sales_point?.door_code,
    sales_point_name: promo.sales_point?.title,
    city: cachedCities[promo.sales_point?.city_id]?.name,
    sales_point_address: promo.sales_point?.address,
    channel: directionValues
      ? `${findKeyByValue(directionValues?.['SalesPoint.Direction'], promo.sales_point?.direction)}`
      : '',
    phone: promo.user && promo.user[0] ? promo.user[0].phone : '',
    fullName:
      promo.user &&
      `${promo.user[0] && promo.user[0].last_name ? promo.user[0].last_name : ''} ${
        promo.user[0] && promo.user[0].first_name ? promo.user[0].first_name : ''
      } ${promo.user[0] && promo.user[0].middle_name ? promo.user[0].middle_name : ''}`,
    reg_date: promo?.participation_date !== null ? dayjs(promo?.participation_date).format('YYYY-MM-DD') : '',
    role: promo.user && promo.user[0] ? promo.user[0].user_roles?.map((role) => role.name).join(', ') : '',
    progress: promo.progress ? promo.progress : '',
    bonus: promo.bonus,
    plan: promo.plan === null || promo.plan === undefined ? -1 : promo.plan,
    participation_status: promo.participation_status,
  }));
};
